import { render, staticRenderFns } from "./InPageNavigation.vue?vue&type=template&id=79d69dd1&scoped=true"
import script from "./InPageNavigation.vue?vue&type=script&lang=js"
export * from "./InPageNavigation.vue?vue&type=script&lang=js"
import style0 from "./InPageNavigation.vue?vue&type=style&index=0&id=79d69dd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d69dd1",
  null
  
)

export default component.exports